import React from "react";
import "./assets/styles/App.scss";
import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/Login";
import ProtectedRoute from "./routes/ProtectedRoutes";
import Dashboard from "./pages/Dashboard";
import { useCookies } from "react-cookie";
import PublicRoute from "./routes/PublicRoutes";

function App() {
  const [cookies] = useCookies(["apiKey"]);
  const isAuthenticated = !!cookies.apiKey;

  return (
    <Routes>
      {/* Redirect "/" based on authentication */}
      <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />

      {/* Public Route (Prevent access when authenticated) */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />

      {/* Protected Route */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* Handle all unknown routes */}
      <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />
    </Routes>
  );
}

export default App;